// КОПИ ЭКРАНА ШАГА 5 — строки, которые принадлежат только шагу 5 (B7-3).
//
// ⛔ ЗАГОЛОВОК, КУРСИВ, КЭП И БАНК БРОВИ ЗДЕСЬ НЕ ЖИВУТ. Это банк §IV, и шаг 5 читает его из общего
// узла — `src/copy/findingBank.js` (подлежащее + предикат) и `src/copy/chartCopy.js` (курсив в форме
// визарда, бровь, `NUMW`, `t.ev.silent`). Парити `wizard-s5-copy.test.js` держит это машинно.
//
// Источник строк ниже — байт `Life Map - s5 Red Line v7.html` (sha `6a1fbb7a…`) там, где решения
// против нет, и решения там, где борд отстал (строки реестра `WIZARD-CANON.md`).

import { NUMW } from '../../copy/chartCopy.js';

/** CTA — строка решения `s945.d2`; v7 печатает `see it over your memories` (отставание борда). */
export const S5_CTA = 'See your Life Map';

/** Возврат — локнутый литерал `s456.d6` (v7 `:633`). Стрелка в тексте, не в css. */
export const S5_BACK = '← back to the layered map';

/** Шапка шторки среза (`t.cut.hd`, v7 `:706`, `s456.d4`). Строка живёт здесь, одна. */
export const cutHead = (i, n, roman) => `stage · ${roman(i)} of ${n} · carries the line`;

/** Кнопка закрытия шторки среза (v7 `:711`, `<button id="shclose">close</button>`). */
export const CUT_CLOSE = 'close';

/**
 * Подпись полюса у слоя без ответа на этапе — байт ШАГА 4 (`s4 Layered Map v10` `:595`,
 * `sheetStage()`): у v7 шага 5 серия мока есть всегда, и ветки «нет ответа» в его `cutSheet()` нет,
 * хотя классы `.crow.nil` / `.bar .nul` в его css объявлены. Взята строка соседнего борда той же
 * шторки, а не сочинена; расхождение — строка реестра отставаний шага 5 (`WIZARD-CANON.md`).
 */
export const CUT_NO_ANSWER = 'no answer';

/** Правая половина статуса (v7 `:617`): `N stages · carrier`. */
export const s5Count = (n) => `${n} stages · `;
export const S5_COUNT_TAIL = 'carrier';

/** Левая бровь чарта (`s7.chart_frame.gtag_tl`, v7 `:558`): `pattern · long arc · M / N`. */
export const GTAG_HEAD = 'pattern';
export const GTAG_ARC = 'long arc';

/** Ярлык карточки имени (v7 `:610`, вариант по умолчанию — `nameHTML()` без `S.card`). */
export const NAME_RAIL = 'main pattern';

/**
 * «Кто» карточки имени (`whoLine()` v7 `:468–473`), только кто — механизм снят (`s454.d5`).
 *
 * ⚠️ ДВЕ ВЕТКИ НЕ ПО БОРДУ, И ОБЕ НАЗВАНЫ:
 *   · `scatter` — у v7 здесь `no single line carries it` (повтор заголовка), у `Scatter Final` —
 *     `all seven layers` при любом составе. Решение `s954.d2`: АКТИВНЫЕ слои через ` + `, при семи
 *     и в запасном случае (активных нет) — `all seven layers`. `names` — активные, не несущие.
 *   · `field` — v7 печатает `all seven layers` при любом числе несущих (его макет поля всегда из
 *     семи). Решение `s952.d1`: при 4–6 несущих — имена через ` + `, при семи — `all seven layers`.
 *
 * @param {string} config `carrierConfig`
 * @param {string[]} names печатные имена несущих в порядке вывода
 */
export function whoLine(config, names) {
  switch (config) {
    case 'singleton': return names[0];
    case 'split': return `${names[0]} against ${names[1]}`;
    case 'field': return names.length >= 7 ? ALL_SEVEN_LAYERS : names.join(' + ');
    case 'scatter': return names.length >= 1 && names.length < 7 ? names.join(' + ') : ALL_SEVEN_LAYERS;
    default: return names.join(' + ');
  }
}

const ALL_SEVEN_LAYERS = 'all seven layers';

/**
 * Кнопка пропуска reveal (`s7.skip_cta`, v7 `:634` — `skip`; регистр печатает CSS, `.skip` `:139`).
 * Видна только в фазе анимации (`s952.d2` п. 4).
 */
export const SKIP_LABEL = 'skip';

/** Строка под карточкой имени при scatter (`s456.d12`, `Scatter Final` `:154`). */
export const SCATTER_FLOOR = 'carried it through every stage.';

/** Подзаголовок доказательств (`s7.evidence_subhead`, v7 `:596`) по ПОЛНОМУ списку M. */
export const evidenceHead = (m) => `${NUMW[m] || m} ${m === 1 ? 'stage' : 'stages'} it ran through`;

/** Подсказка справа от подзаголовка (v7 `:596`) — тап открывает срез (B7-5). */
export const EV_TAP_HINT = 'tap a stage ⤢';

/** Потолок карточек-доказательств — шесть самых свежих (`s679.d1`, v7 `:414`). Только карточки. */
export const EV_CARD_CAP = 6;
